import React from 'react';
import LiftingFormCalculator from './LiftingFormCalculator';

function App() {
  return <LiftingFormCalculator />;
}

export default App;
